// extracted by mini-css-extract-plugin
export default {"app":"andHomePage_app__KGORK","mainContent":"andHomePage_mainContent__A3z6q","container":"andHomePage_container__VQLZe"};